import script from "./HelpCenterPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpCenterPanel.vue?vue&type=script&setup=true&lang=ts"

import "./HelpCenterPanel.vue?vue&type=style&index=0&id=666ad65a&lang=css"

const __exports__ = script;

export default __exports__